/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Popup,
  Modal,
  Icon,
} from 'semantic-ui-react';
import cx from 'classnames';
import withScrollbar from '../Extensions/WithScrollbar';
import api from '../../api';
import ScannedFilesInfoModal from '../Modal/ScannedFilesInfoModal';
import RenderProjectTree from '../Extensions/RenderProjectTree';
import closeBtn from '../../images/components/new_scan/close-btn.svg';

class SecurityRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMSF: false,
      isOpenMEV: false,
      scannedFileIds: [],
      securityTreeData: [],
      popupStatus: {
        treePopup: false,
        evidencePopup: false,
      },
      activeTreeIndex: '',
      activeModalIndex: '',
      description: '',
      status: '',
    };
    this.handleTreeOpen = this.handleTreeOpen.bind(this);
    this.handleComponentFileModal = this.handleComponentFileModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleComponentFileModal = (ids) => {
    this.setState({
      scannedFileIds: ids,
      isOpenMSF: true,
    });
  };

  handleDetailModal = (row, id) => {
    const status = {
      treePopup: false,
      evidencePopup: true,
    };

    this.setState({
      popupStatus: status,
      activeModalIndex: id,
      description: row.evidence_description,
      status: row.evidence_status,
      isOpenMEV: true,
    });
  };

  handleTreeOpen(id, uids) {
    const obj = JSON.parse(`[${uids}]`);
    const objData = { uploaded_file_ids: obj };
    const status = {
      treePopup: true,
      evidencePopup: false,
    };

    api
      .getProjectTree(objData)
      .then((response) => {
        const data = response.response;
        this.setState({
          securityTreeData: data,
          popupStatus: status,
          activeTreeIndex: id,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  closeModal() {
    this.setState({
      isOpenMSF: false,
      isOpenMEV: false,
      description: '',
      status: '',
      activeModalIndex: '',
    });
  }

  closePopup() {
    const { isOpenMSD } = this.state;

    if (isOpenMSD) {
      return;
    }

    const popupStatus = {
      treePopup: false,
      evidencePopup: false,
    };

    this.setState({
      popupStatus,
      activeTreeIndex: '',
      activeModalIndex: '',
    });
  }

  renderTreeTable(obj) {
    const { t } = this.props;
    const { activeModalIndex } = this.state;

    let totalCount = 0;
    for (let i = 0; i < Object.keys(obj).length; i++) {
      const arr = obj[Object.keys(obj)[i]];
      for (let j = 0; j < arr.length; j++) {
        totalCount++;
      }
    }

    return (
      Object.keys(obj).map((groupDetail, k) => {
        return (
          obj[groupDetail].map((file, l) => {
            return (
              <tr
                className=""
                key={`${file.component_name}_${file.component_version}_${file.scanned_file_name}`}
              >
                {
                  k === 0 && l === 0 ? (
                    <td className="tac border-bottom" rowSpan={totalCount}>
                      {file.component_name}
                    </td>
                  ) : null
                }
                {
                  l === 0 ? (
                    <td className="tac border-bottom" rowSpan={obj[groupDetail].length}>
                      {file.component_version}
                    </td>
                  ) : null
                }
                <td className="tac border-bottom has_link">
                  <span
                    onClick={() => {
                      return this.handleComponentFileModal(file.scanned_file_ids);
                    }}
                    onKeyUp={() => {
                      return this.handleComponentFileModal(file.scanned_file_ids);
                    }}
                  >
                    {file.scanned_file_name}
                  </span>
                </td>
                <td className="tac border-bottom">
                  <div
                    className={cx('single_hover_area', {
                      active:
                        activeModalIndex
                        === `${file.component_name}_${file.component_version}_${file.scanned_file_name}`,
                    })}
                    onClick={() => {
                      return this.handleDetailModal(
                        file,
                        `${file.component_name}_${file.component_version}_${file.scanned_file_name}`
                      );
                    }}
                    onKeyUp={() => {
                      return this.handleDetailModal(
                        file,
                        `${file.component_name}_${file.component_version}_${file.scanned_file_name}`
                      );
                    }}
                  >
                    <i className="magnify icon" />
                    <span>{t(`list.title.${file.evidence_status}`)}</span>
                  </div>
                </td>
              </tr>
            );
          })
        );
      })
    );
  }

  render() {
    const {
      rowData,
      uid,
      t,
      location,
      params,
      state,
    } = this.props;

    const {
      isOpenMSF,
      scannedFileIds,
      popupStatus,
      activeTreeIndex,
      securityTreeData,
      isOpenMEV,
      description,
      status,
    } = this.state;

    const pathname = location.pathname ? location.pathname : location;

    if (pathname.indexOf(params.idReport) > -1) {
      return Object.keys(rowData.securities).map((groupName) => {
        return (
          <table
            className="wide_card_table wide_card_item"
            key={groupName.toString()}
          >
            <colgroup>
              <col style={{ width: '28.32%' }} />
              <col style={{ width: '28.32%' }} />
              <col style={{ width: '28.32%' }} />
              <col style={{ width: '15.03%' }} />
            </colgroup>
            <tbody>
              {this.renderTreeTable(rowData.securities[groupName])}
            </tbody>
            <ScannedFilesInfoModal
              isOpenMSF={isOpenMSF}
              closeModal={this.closeModal}
              ufid={uid}
              scannedFileIds={scannedFileIds}
              translate={t}
            />
            <Modal open={isOpenMEV} onClose={this.closeModal}>
              <div className="setting_popup_wrap">
                <div className="setting_popup default_popup security_detail">
                  <div className="header_wrap">
                    <h3 className="ui header">
                      <div className="name_wrap">
                        <Icon name="shield" size={20} />
                        {status && t(`list.title.${status}`)}
                      </div>
                    </h3>
                    <a
                      className="popup_close_button"
                      style={{ cursor: 'pointer' }}
                      onClick={this.closeModal}
                      onKeyUp={this.closeModal}
                    >
                      <img src={closeBtn} alt="" />
                    </a>
                  </div>
                  <Modal.Content scrolling="true">
                    {description !== '' ? (
                      <div className="ui segment">
                        <h4 className="ui header">
                          {t('list.title.description')}
                        </h4>
                        <div className="ui list list_wrap">{description}</div>
                      </div>
                    ) : (
                      <div className="ui placeholder segment">
                        <div className="ui icon header">
                          <Icon name="info circle" />
                          {t('modal.component_detail.no_description')}
                        </div>
                      </div>
                    )}
                  </Modal.Content>
                  <div className="setting_popup_button_wrap">
                    <a
                      className="center_button"
                      onClick={this.closeModal}
                      onKeyUp={this.closeModal}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </Modal>
          </table>
        );
      });
    }
    return Object.keys(rowData.securities).map((groupName) => {
      return (
        <table
          className="wide_card_table wide_card_item"
          key={groupName.toString()}
        >
          <colgroup>
            <col style={{ width: '12.9%' }} />
            <col style={{ width: '12.9%' }} />
            <col style={{ width: '55.5%' }} />
            <col style={{ width: '18.6%' }} />
          </colgroup>
          <tbody>
            {
              rowData.securities[groupName].map((array, k) => {
                return (
                  <tr
                    key={`${groupName}_${array.component_version}`}
                  >
                    {
                      k === 0 ? (
                        <td
                          className="tac border-bottom"
                          style={{ paddingLeft: '7px' }}
                          rowSpan={
                            rowData
                              .securities[groupName]
                              .length
                          }
                        >
                          {array.component_name}
                        </td>
                      ) : null
                    }
                    <td className="tac border-bottom">
                      {array.component_version}
                    </td>
                    <td className="sum_td border-bottom">
                      <Popup
                        trigger={(
                          <div
                            className="hover_area"
                          >
                            <table className="sub_table">
                              <colgroup>
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">
                                    {array.project_count}
                                  </td>
                                  <td className="tac">
                                    {array.project_version_count}
                                  </td>
                                  <td className="tac">
                                    {array.uploaded_file_count}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        on="click"
                        position="bottom left"
                        open={
                          popupStatus.treePopup && activeTreeIndex === `${groupName}_${array.component_version}`
                        }
                        onOpen={() => {
                          return this.handleTreeOpen(`${groupName}_${array.component_version}`, array.uploaded_file_ids);
                        }}
                        onClose={this.closePopup}
                        wide="very"
                      >
                        <RenderProjectTree
                          treeData={securityTreeData}
                          translate={t}
                          tableType
                          state={state}
                        />
                      </Popup>
                    </td>
                    <td className="tac border-bottom">
                      {array.last_detected}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      );
    });
  }
}

export default withScrollbar(SecurityRow);
